import _ from 'lodash';
import PropTypes from 'prop-types';
import { UserManager } from 'oidc-client';
import { useSelector } from 'react-redux';
import React, { createContext, useState } from 'react';

import { useOidc } from '../helpers/hooks/useOidc';
import { useOidcEvents } from '../helpers/hooks/useOidcEvents';

export const OidcContext = createContext({});

export let userManager;

const OidcContextProvider = props => {
  const oidcConfig = useSelector((state) => _.get(state, `environment.oidc`));
  const [evaluatedOidcProps, setEvaluated] = useState(false);

  if (!userManager) {
    userManager = new UserManager({
      authority: oidcConfig.issuer,
      client_id: oidcConfig.clientId,
      response_type: `code`,
      scope: `openid userDetail Roles`,
      redirect_uri: oidcConfig.redirectUrl,
      response_mode: `query`,
      automaticSilentRenew: true,
      validateSubOnSilentRenew: true,
      silent_redirect_uri: oidcConfig.silentRedirectUrl,
      post_logout_redirect_uri: oidcConfig.logoutRedirectUrl,
      revokeAccessTokenOnSignout: true,
      loadUserInfo: false,
      metadataSeed: {
        end_session_endpoint: oidcConfig.endSessionEndpoint
      }
    });
  }
  
  const { isAuthenticated, isAuthorized } = useOidc(userManager, setEvaluated);

  useOidcEvents(userManager);
  
  return (
    <OidcContext.Provider value={{
      isAuthenticated,
      isAuthorized
    }}>
        {
          evaluatedOidcProps
            ? props.children
            : null
        }
    </OidcContext.Provider>
  );
};

export default OidcContextProvider;

OidcContextProvider.propTypes = {
  children: PropTypes.oneOfType([ PropTypes.string, PropTypes.node ])
};